import { styled } from 'styled-components'

const Ellipsis = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export default Ellipsis
